import {
    GroupRideRiderContract,
    RiderColor,
} from '@polaris-customerweb/sharedcomponents.core';
import { GeoCoordinate } from '@polaris-customerweb/sharedcomponents.shared';
import { cloneDeep } from 'lodash-es';

export class RideGroupRider {
    private rawRideGroupRider: GroupRideRiderContract;

    constructor(dto: GroupRideRiderContract) {
        this.rawRideGroupRider = cloneDeep(dto);
    }

    get color(): RiderColor {
        return this.rawRideGroupRider.color || 'Blue';
    }

    get coordinates(): GeoCoordinate | undefined {
        const coordinateArray = this.rawRideGroupRider.coordinates;

        if (!(coordinateArray?.[0].lat && coordinateArray[0].lon)) {
            return undefined;
        }

        return GeoCoordinate.fromCoordinateArray([
            coordinateArray[0].lon,
            coordinateArray[0].lat,
        ]);
    }

    get handle(): string {
        return this.rawRideGroupRider.handle || '';
    }

    get deviceId(): string {
        return this.rawRideGroupRider.deviceId || '';
    }

    get id(): string {
        return this.rawRideGroupRider.id || '';
    }

    get email(): string {
        return this.rawRideGroupRider.email || '';
    }

    get riderId(): string {
        return this.rawRideGroupRider.riderId || '';
    }

    get status(): string {
        return this.rawRideGroupRider.status || '';
    }

    clone(): RideGroupRider {
        return new RideGroupRider(this.toContract());
    }

    toContract(): GroupRideRiderContract {
        return cloneDeep(this.rawRideGroupRider);
    }
}
